/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment
 */
export interface ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment
     */
    description_program_srvc_accom_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment
     */
    grants_and_allocations_amt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment
     */
    foreign_grants_ind?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment
     */
    program_service_expenses_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishmentFromJSON(json: any): ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment {
    return ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishmentFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description_program_srvc_accom_txt': !exists(json, 'description_program_srvc_accom_txt') ? undefined : json['description_program_srvc_accom_txt'],
        'grants_and_allocations_amt': !exists(json, 'grants_and_allocations_amt') ? undefined : json['grants_and_allocations_amt'],
        'foreign_grants_ind': !exists(json, 'foreign_grants_ind') ? undefined : json['foreign_grants_ind'],
        'program_service_expenses_amt': !exists(json, 'program_service_expenses_amt') ? undefined : json['program_service_expenses_amt'],
    };
}

export function ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishmentToJSON(value?: ExecRiskApiAppCoreModelsScansIRS990EZProgramSrvcAccomplishment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description_program_srvc_accom_txt': value.description_program_srvc_accom_txt,
        'grants_and_allocations_amt': value.grants_and_allocations_amt,
        'foreign_grants_ind': value.foreign_grants_ind,
        'program_service_expenses_amt': value.program_service_expenses_amt,
    };
}

